var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('div',[_c('h3',[_vm._v("알 수 없는 페이지입니다")]),_c('router-link',{staticClass:"mt-6",attrs:{"to":{ name: _vm.registerInformationRouterName }}},[_vm._v(" 메인 페이지로 이동 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }